import type { CheckpointStatus, CheckpointType, ProjectStatus } from '../types';

// Status pill colours — the only real "visual element" in the list, per the
// brief (few visual elements, colour per status).
export const PROJECT_STATUS_META: Record<ProjectStatus, { label: string; className: string }> = {
  active: { label: 'Aktiv', className: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  blocked: { label: 'Blokkert', className: 'bg-red-100 text-red-800 border-red-200' },
  waiting: { label: 'Venter', className: 'bg-amber-100 text-amber-800 border-amber-200' },
  idea: { label: 'Idé', className: 'bg-violet-100 text-violet-800 border-violet-200' },
  maintenance: { label: 'Vedlikehold', className: 'bg-sky-100 text-sky-800 border-sky-200' },
  done: { label: 'Ferdig', className: 'bg-slate-200 text-slate-700 border-slate-300' },
};

export const PROJECT_STATUS_ORDER: ProjectStatus[] = [
  'active',
  'blocked',
  'waiting',
  'idea',
  'maintenance',
  'done',
];

export const CHECKPOINT_TYPE_META: Record<CheckpointType, { label: string; icon: string; className: string }> = {
  blocker: { label: 'Blocker', icon: '🔴', className: 'text-red-700' },
  waiting_for: { label: 'Venter på', icon: '⏳', className: 'text-amber-700' },
  todo: { label: 'To-do', icon: '⬜', className: 'text-slate-600' },
};

export const CHECKPOINT_STATUS_META: Record<CheckpointStatus, { label: string; className: string }> = {
  open: { label: 'Åpen', className: 'text-slate-500' },
  checking: { label: 'Sjekker', className: 'text-sky-600' },
  resolved: { label: 'Løst', className: 'text-emerald-600 line-through' },
};
